import React from 'react'
import Fade from 'react-reveal/Fade'
import CurveUnderline from 'images/curve-underline.inline.svg'

const Header1 = ({ children, className }) => <h1 className={ `h1 ${ className }`}>{ children }</h1>
const Header2 = ({ children, className }) => <h2 className={ `h2 ${ className }`}>{ children }</h2>
const Header3 = ({ children, className }) => <h3 className={ `h3 ${ className }`}>{ children }</h3>
const Header4 = ({ children, className }) => <h4 className={ `h4 ${ className }`}>{ children }</h4>
const Header5 = ({ children, className }) => <h5 className={ `h5 ${ className }`}>{ children }</h5>
const Header6 = ({ children, className }) => <h6 className={ `h6 ${ className }`}>{ children }</h6>

const HeaderUnderline = props => {

    let underlineClass = ''

    if ( props.underlineClass ) {
        underlineClass = props.underlineClass
    } else {
        underlineClass = 'text-black w-full h-auto'
    }

    return (
        <div className={ `inline-block ${ props.className }` }>
            <Fade>
                <h2 className={ `text-4xl uppercase font-bold mb-4 md:text-7xl ${ props.titleClass ? props.titleClass : ''  }` }>{ props.title }</h2>
                <CurveUnderline className={ underlineClass } />
            </Fade>
        </div>
    )
}

export { Header1, Header2, Header3, Header4, Header5, Header6, HeaderUnderline }
